import React from 'react';
import { string, bool } from 'prop-types';
import {
  BarChart, XAxis, YAxis, ResponsiveContainer, ReferenceLine, ReferenceArea, Label
} from 'recharts';

import VariableSummaryLegend from '../VariableSummaryLegend';
import { variableStatsType } from '../../../constants/types';
import styles from './relativeVariableSummary.module.css';
import variables from '../../../styles/variables.json';

const {
  blue, red, orange, black, darkSilver
} = variables;

const toPercentage = (val) => `${(val * 100).toFixed(0)}%`;

const yDomain = [0, 1];
const yTicks = Array.from({ length: 12 }, (v, k) => k / 10);
const xAxisKey = 'x';

function RelativeVariableSummary(props) {
  const {
    feedback,
    responseOptionValues,
    average,
    distribution,
    userAverage,
    standardDeviation,
    minAverage,
    maxAverage
  } = props.stats;

  const xTicks = responseOptionValues;
  const xData = responseOptionValues.map((v) => ({ [xAxisKey]: v }));
  const xMinValue = Math.min(...xTicks);
  const xMaxValue = Math.max(...xTicks);
  const xDomain = [xMinValue, xMaxValue];

  return (
    <figure aria-label={props.label}>
      <div className={styles.chart} aria-hidden>
        <ResponsiveContainer debounce={300}>
          <BarChart
            data={xData}
          >
            <XAxis
              stroke={darkSilver}
              type="number"
              dataKey={xAxisKey}
              interval={0}
              tickLine={false}
              ticks={xTicks}
              domain={xDomain}
            />
            <YAxis
              stroke={darkSilver}
              domain={yDomain}
              tickLine={false}
              ticks={yTicks}
              tickFormatter={toPercentage}
              interval={4}
            />
            {
              Object.keys(distribution).map((k) => (
                <ReferenceArea
                  key={k}
                  fill={blue}
                  x1={Number(k)}
                  x2={Number(k) + 0.99}
                  y1={0}
                  y2={distribution[k]}
                  strokeWidth={0}
                  fillOpacity={1}
                >
                  <Label value={toPercentage(distribution[k])} fill={black} position="top" />
                </ReferenceArea>
              ))
            }
            <ReferenceLine x={average} stroke={red} strokeWidth={2} />
            <ReferenceLine x={userAverage} stroke={orange} strokeWidth={2} />

          </BarChart>
        </ResponsiveContainer>
      </div>
      <figcaption className={styles.figcaption}>
        <VariableSummaryLegend
          userValue={userAverage}
          userKey="surveySummary.userAverage"
          groupValue={average}
          groupKey="surveySummary.groupAverage"
          feedback={feedback}
          standardDeviation={standardDeviation}
          showStandardDeviation={props.showStandardDeviation}
          distribution={distribution}
          minAverage={minAverage}
          maxAverage={maxAverage}
        />
      </figcaption>
    </figure>
  );
}

RelativeVariableSummary.propTypes = {
  stats: variableStatsType.isRequired,
  showStandardDeviation: bool,
  label: string.isRequired
};

RelativeVariableSummary.defaultProps = {
  showStandardDeviation: false
};

export default RelativeVariableSummary;
